module.exports = __webpack_public_path__ + "img/speed.677b5bc0.svg";